import axios from "axios";
import { pagesActions, pagesPath } from "../configs/dictionaryAccessRules";
import terms from "./terms.json";

function formatPermissions(acoesSistema) {
  let screens = {};
  (acoesSistema || []).forEach((item) => {
    if (!Object.keys(screens).includes(item.tela)) {
      let actions = {};
      acoesSistema.forEach((action) => {
        if (item.tela === action.tela) {
          const actionKey = pagesActions[action.identificador];
          actions[actionKey || action.identificador] = true;
        }
      });
      const screenKey = pagesPath[item.tela] || item.tela;
      screens[screenKey] = actions;
    }
  });
  return screens;
}

function extractEmailFromToken(token) {
  try {
    return atob(token).split(";")[8] ?? null;
  } catch {
    return null;
  }
}

/**
 * Em desenvolvimento local, autentica direto com um token gerado manualmente
 * (REACT_APP_DEV_AUTH_TOKEN em .env.development.local, não versionado),
 * sem passar pelo redirecionamento ao autenticador externo.
 *
 * O token já é aceito pela API como Authorization em qualquer endpoint, então
 * em vez de reproduzir o handshake RenovarTokenUsuario (que exige
 * identificadorUsuario/identificadorConta vindos do autenticador), buscamos as
 * permissões reais do usuário e populamos o localStorage diretamente — é o
 * mesmo formato que loadUserFromStorage() lê no boot da aplicação.
 *
 * Eliminado do bundle de produção pelo minificador (NODE_ENV !== "development").
 */
export async function bootstrapDevToken() {
  if (process.env.NODE_ENV !== "development") return;

  const devToken = process.env.REACT_APP_DEV_AUTH_TOKEN;
  if (!devToken) return;

  if (localStorage.getItem("userInfo")) return;

  const baseUrl = `${process.env.REACT_APP_FISCOLFRONT_API_URL}/${process.env.REACT_APP_FISCOLFRONT_API_URI}`;
  const headers = { Authorization: devToken };

  try {
    const [acoesRes, contratosRes] = await Promise.all([
      axios.get(`${baseUrl}/Account/BuscarAcoesSistemaUsuario`, { headers }),
      axios.get(`${baseUrl}/Contrato/Listar`, { headers }),
    ]);

    const contratos = contratosRes.data?.data ?? [];

    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        token: JSON.stringify({ token: devToken }),
        email: extractEmailFromToken(devToken),
        versaoTermosUso: terms.version,
        usuarioInlog: true,
        contratos,
        acoesSistema: formatPermissions(acoesRes.data?.data),
      })
    );

    // Replica o que o login real faz antes do reload de página: grava o branch
    // selecionado em localStorage para o loadUserFromStorage() hidratar o
    // redux ANTES do primeiro mount do ProtectedRoute. Sem isso, o
    // useEffect do ProtectedRoute (que despacha um branch padrão hardcoded)
    // corre com o do customHeader (que despacha o contrato real) e às vezes
    // vence, sobrescrevendo o branch real com o placeholder "Filial Inlog".
    if (contratos[0]) {
      localStorage.setItem("branch", JSON.stringify(contratos[0]));
    }
  } catch (err) {
    console.warn("[devAuthBootstrap] falha ao autenticar com REACT_APP_DEV_AUTH_TOKEN:", err);
  }
}
